import moment from 'moment';
import { useState } from 'react';
import { Col, Row, Space } from 'antd';
import Button from 'components/new-ui/base/button/Button';
import DatePicker from 'components/new-ui/base/date-picker/DatePicker';
import SearchBar from 'components/new-ui/base/searchbar/SearchBar';
import { StyledTag } from 'components/new-ui/base/tag/styles';
import { DeclarationStatuses, getDeclarationStatusLabel } from 'store/declarations/enums/common/declaration-status';
import ArrivalNotificationsFiltersModal from './ArrivalNotificationsFiltersModal';
import { ARRIVAL_DATE_FORMAT, ArrivalFilterKey, ArrivalFilters } from './useArrivalNotificationsList';

type Props = {
    mrnSearch: string;
    filters: ArrivalFilters;
    onMrnSearch: (mrn: string | null) => void;
    onApply: (key: ArrivalFilterKey, value: string | undefined) => void;
    onRemove: (key: ArrivalFilterKey) => void;
    onClearAll: () => void;
};

const getModalFilterTags = ({ status, lrn, relatedMrn }: ArrivalFilters) => {
    const tags: { key: ArrivalFilterKey; label: string }[] = [];

    if (status)
        tags.push({ key: 'status', label: `Status: ${getDeclarationStatusLabel(status as DeclarationStatuses)}` });
    if (lrn) tags.push({ key: 'lrn', label: `LRN: ${lrn}` });
    if (relatedMrn) tags.push({ key: 'relatedMrn', label: `ENS MRN: ${relatedMrn}` });

    return tags;
};

const ArrivalNotificationsFilters = ({ mrnSearch, filters, onMrnSearch, onApply, onRemove, onClearAll }: Props) => {
    const [isModalOpen, setIsModalOpen] = useState(false);

    const tags = getModalFilterTags(filters);

    return (
        <>
            <Row justify="space-between">
                <Col>
                    <Space size={8}>
                        <SearchBar
                            style={{ width: 360 }}
                            inputPlaceholder="Search by MRN"
                            value={mrnSearch}
                            onChange={onMrnSearch}
                        />
                        <Button onClick={() => setIsModalOpen(true)}>Filter</Button>
                    </Space>
                </Col>
                <Col>
                    <DatePicker
                        value={filters.arrivalDate ? moment(filters.arrivalDate, ARRIVAL_DATE_FORMAT) : undefined}
                        onChange={(date) => onApply('arrivalDate', date?.format(ARRIVAL_DATE_FORMAT))}
                    />
                </Col>
            </Row>

            {tags.length > 0 && (
                <Row style={{ marginTop: 16 }}>
                    {tags.map(({ key, label }) => (
                        <StyledTag
                            key={key}
                            closable
                            onClose={(event) => {
                                event.preventDefault();
                                onRemove(key);
                            }}
                        >
                            {label}
                        </StyledTag>
                    ))}
                    <Button type="link" onClick={onClearAll}>
                        Clear All Filters
                    </Button>
                </Row>
            )}

            <ArrivalNotificationsFiltersModal
                open={isModalOpen}
                filters={filters}
                onApply={onApply}
                onClearAll={onClearAll}
                onClose={() => setIsModalOpen(false)}
            />
        </>
    );
};

export default ArrivalNotificationsFilters;
